module.exports = __webpack_public_path__ + "img/44-b5df61.png";